import { MasonryTextActionRenderer } from '@leagueplatform/masonry-renderers';

export const FitContentActionLinkRenderer: typeof MasonryTextActionRenderer = ({
  css, // eslint-disable-line react/prop-types
  ...props
}) => (
  <MasonryTextActionRenderer
    {...props}
    css={{
      ...css,
      alignSelf: 'flex-start',
      width: 'fit-content',
    }}
  />
);
